// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prove-wrapper .el-row[data-v-838ca87e]{margin:0 calc(0px - var(--base-size-16))}.prove-wrapper .el-row .el-col[data-v-838ca87e]{padding:0 var(--base-size-16)}", ""]);
// Exports
module.exports = exports;
